import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
export function Bonos() {
  const bonos = [{
    num: '#1',
    image: 'https://i.postimg.cc/zfZDggQJ/libro-bono-1.webp',
    title: 'Lista Negra del Reflujo',
    subtitle: 'Los alimentos y combinaciones que más suelen disparar la agrura',
    desc: 'Uno de los mayores errores que cometen las personas que sufren reflujo es pensar que el problema es simplemente comer demasiado. En realidad, muchas veces el problema es comer lo incorrecto, en el momento incorrecto y de la forma incorrecta. Esta guía te ayuda a identificar los disparadores más comunes para que puedas tomar decisiones más conscientes en tu día a día.',
    value: '$4.990'
  }, {
    num: '#2',
    image: 'https://i.postimg.cc/90nCFR9p/libro-bono-2.webp',
    title: 'Guía Express de Cena Sin Castigo',
    subtitle: 'Cómo cenar sin convertir la noche en una batalla digestiva',
    desc: 'Muchas personas con reflujo gastroesofágico notan que los síntomas empeoran por la noche. Cuando nos acostamos, la gravedad deja de ayudar a mantener el ácido dentro del estómago. Si la cena fue pesada o demasiado tarde, el sistema digestivo sigue trabajando mientras el cuerpo intenta descansar.',
    value: '$4.990'
  }, {
    num: '#3',
    image: 'https://i.postimg.cc/mDdG8z8K/libro-bono-3.webp',
    title: 'Protocolo de Emergencia AntiAgrura',
    subtitle: 'Qué hacer cuando el reflujo aparece de repente y cómo responder con calma',
    desc: 'Incluye el Protocolo SOS: Reflujo 11 PM — cómo apagar el fuego en tu garganta y volver a dormir en 15 minutos sin depender del Omeprazol. Cubre los detonantes más comunes: comida pesada, cena tardía, estrés intenso y combinaciones de alimentos que disparan la acidez.',
    value: '$5.990'
  }];
  const bonoEspecial = {
    title: 'Protocolo Natural para el Reflujo',
    subtitle: 'Basado en las enseñanzas del Dr. Oswaldo Restrepo',
    desc: 'Resumen del video educativo del Dr. Oswaldo Restrepo, médico y divulgador de salud, donde explica de forma clara por qué ocurre el reflujo ácido y cómo puede aliviarse utilizando cambios digestivos y un remedio natural simple. El enfoque principal: el reflujo no siempre ocurre por exceso de ácido, sino muchas veces por una digestión deficiente y baja producción de ácido estomacal.'
  };
  return <section id="bonos" className="bg-crema-oscuro py-[100px]" data-id="element-69">
      <div className="container-custom" data-id="element-70">
        <SectionHeader eyebrow="Bonos exclusivos" title={<>
              Todo lo que se suma
              <br data-id="element-72" />
              sin costo adicional
            </>} description="Por este período de lanzamiento, recibís estos tres recursos que multiplican los resultados del protocolo." theme="light" data-id="element-71" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-[60px]" data-id="element-73">
          {bonos.map((bono, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="bg-blanco rounded-[8px] overflow-hidden border border-black/5 hover:shadow-[0_12px_40px_rgba(0,0,0,0.1)] transition-shadow duration-300 flex flex-col" data-id="element-74">
              <div className="bg-verde p-5 flex items-center justify-between" data-id="element-75">
                <div className="flex items-center gap-2" data-id="element-76">
                  <span className="bg-dorado text-verde-oscuro text-[11px] font-bold tracking-[1px] uppercase px-2.5 py-1 rounded-[2px]" data-id="element-77">
                    HOY GRATIS
                  </span>
                  <span className="text-white/80 text-[12px] font-semibold tracking-[0.5px]" data-id="element-78">
                    BONO {bono.num}
                  </span>
                </div>
                <span className="text-[13px] text-white/55 line-through" data-id="element-79">
                  Valor: {bono.value}
                </span>
              </div>

              <div className="p-6 flex-1 flex flex-col" data-id="element-80">
                <div className="w-full aspect-[3/4] rounded-[10px] mb-5 bg-gradient-to-br from-dorado/5 via-verde/10 to-dorado/5 flex items-center justify-center p-3 ebook-shine ebook-glow" style={{
              animationDelay: `${idx * 0.8}s`
            }} data-id="element-81">
                  <img src={bono.image} alt={bono.title} className="w-full h-full object-contain animate-float-premium max-h-[420px] drop-shadow-[0_10px_30px_rgba(201,162,39,0.15)]" loading="lazy" style={{
                animationDelay: `${idx * 0.5}s`
              }} data-id="element-82" />
                </div>
                <h3 className="font-display text-[17px] font-bold text-verde-oscuro mb-1" data-id="element-83">
                  {bono.title}
                </h3>
                <p className="text-[15px] md:text-[14px] text-verde-medio font-medium mb-3 italic" data-id="element-84">
                  {bono.subtitle}
                </p>
                <p className="text-[16px] md:text-[15px] text-gris leading-[1.7]" data-id="element-85">
                  {bono.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-10 bg-verde-oscuro rounded-[12px] p-8 md:p-10 border border-dorado/20 relative overflow-hidden" data-id="element-86">
          <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-dorado via-dorado-claro to-dorado overflow-hidden" data-id="element-87">
            <div className="absolute inset-0 animate-shimmer" data-id="element-88" />
          </div>
          <div className="flex items-center gap-2 mb-4" data-id="element-89">
            <span className="bg-dorado text-verde-oscuro text-[11px] font-bold tracking-[1px] uppercase px-2.5 py-1 rounded-[2px]" data-id="element-90">
              BONO ESPECIAL
            </span>
          </div>
          <h3 className="font-display text-[22px] font-bold text-blanco mb-1" data-id="element-91">
            {bonoEspecial.title}
          </h3>
          <p className="text-[15px] text-dorado-claro font-medium mb-4 italic" data-id="element-92">
            {bonoEspecial.subtitle}
          </p>
          <p className="text-[16px] text-white/70 leading-[1.8] max-w-[700px]" data-id="element-93">
            {bonoEspecial.desc}
          </p>
        </motion.div>
      </div>
    </section>;
}